import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useAuth } from '@/auth/AuthContext';
import { ThemeToggle } from './ThemeToggle';

export function Header() {
  const { t } = useTranslation();
  const { isConfigured, isAuthenticated, login, logout } = useAuth();

  return (
    <header className="border-b border-slate-200 bg-white/80 backdrop-blur dark:border-slate-800 dark:bg-slate-950/80">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
        <Link to="/" className="text-lg font-semibold text-brand-600 dark:text-brand-400">
          {t('brand')}
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <Link to="/" className="hover:text-brand-600 dark:hover:text-brand-400">
            {t('nav.home')}
          </Link>
          {isAuthenticated && (
            <Link to="/dashboard" className="hover:text-brand-600 dark:hover:text-brand-400">
              {t('nav.dashboard')}
            </Link>
          )}
          {isAuthenticated && (
            <Link to="/profile" className="hover:text-brand-600 dark:hover:text-brand-400">
              {t('nav.profile')}
            </Link>
          )}
          <ThemeToggle />
          {isAuthenticated ? (
            <button
              type="button"
              onClick={() => void logout()}
              className="rounded bg-slate-200 px-3 py-1 text-sm font-medium hover:bg-slate-300 dark:bg-slate-800 dark:hover:bg-slate-700"
            >
              {t('nav.signOut')}
            </button>
          ) : (
            <button
              type="button"
              disabled={!isConfigured}
              onClick={() => void login()}
              title={!isConfigured ? t('auth.notConfigured') : undefined}
              className="rounded bg-brand-600 px-3 py-1 text-sm font-medium text-white hover:bg-brand-700 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {t('nav.signIn')}
            </button>
          )}
        </nav>
      </div>
    </header>
  );
}
